import { safeDefine } from "../../registration/safe-define.js";
import { NeutralLiveVideoSkinElement } from "../../presets/live-video/neutral-skin.js";
import "../../internal/skins/neutral-live-video/register.js";
//#region src/define/live-video/neutral-skin.ts
safeDefine(NeutralLiveVideoSkinElement);
//#endregion
